import React from "react";

const AnalysisCard = ({ title, icon: Icon, bgGradient, description }) => {
  return (
    <div>
      <h3 className="text-gray-300 font-semibold text-base mb-3 px-2">{title}</h3>
      <div className={`${bgGradient} rounded-xl p-6 text-center relative overflow-hidden`}>
        <div className="absolute inset-0 blur-[3px] opacity-40 pointer-events-none select-none p-6">
          <div className="flex flex-col h-full space-y-3">
            <p className="text-gray-300 text-xs">
              Detailed insights and analytics data available
            </p>
            <div className="flex gap-2">
              <div className="bg-gray-600/40 h-2 w-16 rounded"></div>
              <div className="bg-gray-600/40 h-2 w-12 rounded"></div>
              <div className="bg-gray-600/40 h-2 w-14 rounded"></div>
            </div>
            <div className="flex gap-2">
              <div className="bg-gray-600/40 h-2 w-12 rounded"></div>
              <div className="bg-gray-600/40 h-2 w-16 rounded"></div>
            </div>
            <button className="bg-gray-600/40 text-gray-300 text-xs font-medium py-1.5 px-6 rounded-md mt-2">
              View Analysis
            </button>
          </div>
        </div>
        
        <div className="relative z-1">
          <div className="flex justify-center mb-1">
            <div className={`p-3 rounded-lg`}>
              <Icon className={`w-6 h-6 text-primary`} />
            </div>
          </div>
          <p className="text-white text-sm mb-1 font-semibold">Press 'Run analysis'</p>
          <p className="text-white text-sm font-semibold">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default AnalysisCard;